import Circle, { type CircleProps } from '../circle';
import Tag from './tag';

type DotTagProps = {
  children: React.ReactNode;
  variant?: CircleProps['variant'];
};

export { type DotTagProps };

export const DotTag = ({ children, variant = 'positive' }: DotTagProps) => (
  <Tag size={'sm'} gap={'xs'}>
    <Circle size={'micro'} variant={variant} />
    {children}
  </Tag>
);
